import { Outlet } from 'react-router-dom';
import Footer from '../footer/Footer';

const RouteWithFooter = () => {
	return (
		<>
			<Outlet />
			<Footer />
		</>
	);
};

export default RouteWithFooter;
